import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint'
import * as Globals from '../../Globals';

export const Intro = styled.div`
  background-color: #f7f7f7;
`;

export const Content = styled.div`
  padding-bottom: 75px;
  max-width: 1235px;
  margin: 0 auto;
  margin: 0 auto;
  padding: 10% 7%;

  ${breakpoint('medium')`
    padding: 7% 7%;
  `}

  ${breakpoint('large')`
    padding: 5% 2%;
  `}
`

export const Section = styled.div`
  max-width: 820px;
  margin: 0 auto;
`


export const Heading = styled(Globals.H2)`
  margin-bottom: 30px;
`;
export const Subheading = styled(Globals.Description) `
  margin-bottom: 1rem;
  -webkit-font-smoothing: auto;
`;

export const Bold = styled.div`
  font-weight: bold;
`

export const LinkContainer = styled.div`
  text-align: center;
  margin: 0;
  margin-top: 50px;
`

export const Link = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  font-size: .9rem;
  margin: 5px 0;
  color: #1488B6;
  outline: none;
  ::after {
    content: '\f0da';
    font-family: 'FontAwesome';
    color: #1488B6;
    top: 0px;
    margin-left: 5px;
    font-size: 14px;
    position: relative;
  }
`
